import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';
export const BREAKPOINTS = {
  MOBILE: '(max-width: 767px)',
  TABLET: '(min-width: 768px) and (max-width: 1023px)',
  DESKTOP: '(min-width: 1024px)'
} as const;
type BreakpointType = (typeof BREAKPOINTS)[keyof typeof BREAKPOINTS];
export const useMediaQuery = query => {
  const $ = _c(5);
  let t0;
  if ($[0] !== query) {
    t0 = () => {
      if (typeof window !== "undefined") {
        return window.matchMedia(query).matches;
      }
      return false;
    };
    $[0] = query;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [matches, setMatches] = useState(t0);
  let t1;
  let t2;
  if ($[2] !== query) {
    t1 = () => {
      if (typeof window === "undefined") {
        return;
      }
      const media = window.matchMedia(query);
      setMatches(media.matches);
      const listener = () => setMatches(media.matches);
      media.addEventListener("change", listener);
      return () => media.removeEventListener("change", listener);
    };
    t2 = [query];
    $[2] = query;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useIsomorphicLayoutEffect(t1, t2);
  return matches;
};